export default __webpack_public_path__ + "static/media/swathi.ba20a74b.jpg";